export class CoreComponentsConfig {

  componentCreationFunctions?: { [componentId: string]: any };

}
